import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RealtimeEvent } from '@safe-minds-ai/api';

export interface RealtimeState {
  lastEvent: RealtimeEvent | null;
  connectedChannels: Record<string, boolean>;
}

const initialState: RealtimeState = {
  lastEvent: null,
  connectedChannels: {},
};

const realtimeSlice = createSlice({
  name: 'realtime',
  initialState,
  reducers: {
    setLastEvent(state, action: PayloadAction<RealtimeEvent>) {
      state.lastEvent = action.payload;
    },
    setChannelStatus(state, action: PayloadAction<{ channel: string; connected: boolean }>) {
      state.connectedChannels[action.payload.channel] = action.payload.connected;
    },
  },
});

export const { setLastEvent, setChannelStatus } = realtimeSlice.actions;
export const realtimeReducer = realtimeSlice.reducer;
